import { BackendSettings, clearBackendOverrides, setBackendOverrides } from "@hicya/ui/backend";

import type { BackendOverrides, ServiceDefinition } from "@hicya/ui/backend";

const SERVICES: ServiceDefinition[] = [
  { key: "auth", name: "Auth", prodUrl: "https://auth.hicya.org" },
  { key: "sync", name: "Sync", prodUrl: "https://sync.hicya.org" },
];

const PRESETS = [
  {
    key: "production",
    name: "Production",
    urls: { auth: "https://auth.hicya.org", sync: "https://sync.hicya.org" },
  },
  {
    key: "staging",
    name: "Staging",
    urls: { auth: "https://auth-staging.hicya.org", sync: "https://sync-staging.hicya.org" },
  },
];

function handleApply(overrides: BackendOverrides) {
  const allProd = SERVICES.every((s) => !overrides[s.key] || overrides[s.key] === s.prodUrl);
  if (allProd) {
    clearBackendOverrides();
  } else {
    setBackendOverrides(overrides);
  }
  sessionStorage.clear();
  window.location.href = "/";
}

export function Developer() {
  return <BackendSettings services={SERVICES} presets={PRESETS} onApply={handleApply} />;
}
